export enum ServiceMessageType {
    Negative = 'negative',
    Positive = 'positive',
    Info = 'info'
}
